var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"caption font-weight-bold",staticStyle:{"height":"100%"},attrs:{"justify":"center","align":"center"}},[_vm._v(" "+_vm._s(_vm.formatedBilled)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }